import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/ScrollProgressBar.tsx");
